export const ItemImageTypes = {
  configuratorMenuImage:          2,
  configuratorBurgerPreviewImage: 7,
  configuratorBowlPreviewImage:   6,
  configuratorFriesPreviewImage:  8,
};

export const CategoryWizard = {
  UNDEFINED:    1,
  CHECKBOX:     2,
  RADIO:        3,
  CHILD_WIZARD: 4,
};

export const ItemActionType = {
  NO_ACTION:    0,
  NO_CHOICE:    1,
  BREAK_WIZARD: 2,
};

/**
 * Lazy menu products list
 */
export const LazyMenuItems = {
  28: {
    name:            'bossed for you',
    title:           'Do you want cheese?',
    orderIndex:      2,
    showInMenu:      true,
    productKey:      15,
    categoryKey:     67,
    destCategoryKey: 70,
  },
};

export const KidsMenu = {
  PRODUCT_ID:          '18',
  KIDS_BURGER:         '23',
  KIDS_GRILLED_CHEESE: '24',
  KIDS_CHICKEN_STRIPS: '25',
  KIDS_TREASURE_BOX:   '30',
  GRILLED_CHEESE_ITEM: '793',
  CHICKEN_STRIPS_ITEM: '792',
  SUB_PRODUCTS:        [ '23', '24', '30' ],
};

export const KidsMenuPictures = {
  23: 'ProductImages/KidsBYB.png',
  24: 'ProductImages/GrilledCheese.png',
  25: 'ProductImages/ChickenStrips.png',
  30: 'ProductImages/treasure_box_big.png',
};

export const FriesMenu = {
  PRODUCT_ID:                    '26',
  BOSS_YOUR_FIRES_ID:            '26',
  FIRES_ID:                      '16',
  FIRES_FRIES_CATEGORY:          '78',
  CHEESE_ITEM:                   '1046',
  ITEMS:                         [ '682', '683' ],
  BOSS_YOUR_FRIES_PICTURE:       'ProductImages/BYF.png',
  BOSS_YOUR_FRIES_ORDER_PICTURE: 'ProductImages/fries.png',
};

export const NO_BURGER_CHEESE = 507;
export const NO_BOWL_CHEESE = 532;
export const BURGER_DOUBLE_BEEF = 486;
export const BOWL_DOUBLE_BEEF = 493;

export default {
  ItemImageTypes,
  CategoryWizard,
  ItemActionType,
  KidsMenu,
  KidsMenuPictures,
  FriesMenu,
  NO_BOWL_CHEESE,
  NO_BURGER_CHEESE,
  BURGER_DOUBLE_BEEF,
  BOWL_DOUBLE_BEEF,
};



// WEBPACK FOOTER //
// ./src/apps/menu/constants.js